require("!!D:\\Projects\\FRACTAL GAMES\\app.fractalgames.com\\fractal-games-client\\node_modules\\script-loader\\addScript.js")(require("!!D:\\Projects\\FRACTAL GAMES\\app.fractalgames.com\\fractal-games-client\\node_modules\\raw-loader\\index.js!D:\\Projects\\FRACTAL GAMES\\app.fractalgames.com\\fractal-games-client\\node_modules\\hammerjs\\hammer.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/hammerjs/hammer.js
// module id = 221
// module chunks = 3